import Units from "../../../utils/Units";
import Time from "../axes/Time";
import Celsius from "../axes/Celsius";

let MilkTemp2 = {
    type: "line",
    label: "Milk Temperature 2",
    fill: false,
    lineTension: 0,
    colorPalette: 9,
    borderWidth:2,

    pointStyle: "circle",
    pointRadius:0,
    pointHoverRadius: 2,
    pointBorderWidth:.5,
    z:50,

    tooltipLabelValueCallback: (value) => {
        return Units.rounded(value,2);
    },

    yAxis:Celsius,
    xAxis:Time
};

export default MilkTemp2;



// WEBPACK FOOTER //
// ./src/components/chart/channels/MilkTemp2.js